import CallSohunews from "../CallSohunews/callSohunews.vue"
import Vue from 'vue';
import MptcfeUtils from 'mptcfe-utils'
import Supporter from "../../utils/supporter";

const callSohunews = (cfgs) => {
    const isInSohuApp = Supporter.isMSOHU || Supporter.isSohuNews || Supporter.isSohuInfo
    const isBaiduboxapp = Supporter.isBaiduboxapp  // 百度
    const isBaiduSpmB = window?.sohuSpm?.getCodes()?.b === 'content-bd' // b码为百度
    const show = !isInSohuApp && !isBaiduboxapp && !isBaiduSpmB
    if (show) {
        // 命中触发条件展示的所有唤起标签曝光数
        MptcfeUtils.Utils.sendSpmAction(10478)
        if (document.querySelector('#CallAppContainer')) {
            new Vue({
                el: '#CallAppContainer',
                data() {
                    return {
                        newsid: cfgs.clientNewsId,
                    }
                },
                components: {
                    CallSohunews
                }
            })
        }
    }

}
export default {
    callSohunews,
}